'use client'
import React from 'react';
import {FormattedMessage} from "react-intl";
import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton
} from "next-share";
import styles from "@/app/styles/components/pages/blog/share-social-network.module.scss";

const ShareSocialNetwork = ({ thisPostUrl }) => {
    return (
        <div className={styles.socialNetworkShareDiv}>
            <div className={`${styles.btnFacebook} ${styles.btnShare}`}>
                <FacebookShareButton url={thisPostUrl} >
                    <FacebookIcon size={22} round />
                    <FormattedMessage id={'components.pages.blog.shareSocialNetwork.shareOnFacebook'}>
                        {'components.pages.blog.shareSocialNetwork.shareOnFacebook'}
                    </FormattedMessage>
                </FacebookShareButton>
            </div>
            <div className={`${styles.btnTwitter} ${styles.btnShare}`}>
                <TwitterShareButton url={thisPostUrl}>
                    <TwitterIcon size={40} round />
                    <FormattedMessage id={'components.pages.blog.shareSocialNetwork.shareOnTwitter'}>
                        {'components.pages.blog.shareSocialNetwork.shareOnTwitter'}
                    </FormattedMessage>
                </TwitterShareButton>
            </div>
        </div>    
    )
}

export default ShareSocialNetwork;